// src/features/payments/hooks/useStripeConnectMutation.ts
import { useMutation } from '@tanstack/react-query';
import { paymentApis, type StripeConnectResponse } from '../api/paymentApi';
import type { ApiResponse } from '@/shared/types/api';

export const useStripeConnectMutation = () => {
  return useMutation<ApiResponse<StripeConnectResponse>, unknown, void>({
    mutationFn: () => paymentApis.connectToStripe(),
  });
};
